import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import Header from "./components/Header/Header";
import Home from "./pages/home/home";
import LandingPage from "./pages/LandingPage/LandingPage";
import NotFound from "./pages/NotFound/NotFound"; // <-- added
import QuyDinh from "./pages/QuyDinh/QuyDinh";
import ScrollToTop from "./ScrollToTop";

function AppContent() {
  const location = useLocation();
  // Danh sách các route không hiển thị Header
  const routesWithHeader = [
    "/trang-chu",
    "/quy-dinh",
    // "/history",
    "/404",
  ];

  return ( 
    <div className="App">
      {routesWithHeader.includes(location.pathname) && <Header />}
      <Routes>
        <Route path="/" element={<Navigate to="/trang-chu" replace />} />
        <Route path="/2025" element={<Home />} />
        <Route path="/trang-chu" element={<LandingPage />} />
        <Route path="/quy-dinh" element={<QuyDinh />} />
        {/* <Route path="/history" element={<History />} /> */}

        {/* New 404 route */}
        <Route path="/404" element={<NotFound />} />

        {/* Catch-all: chuyển mọi route không khớp về /404 */}
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </div>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppContent />
    </Router>
  );
}

export default App;
